import styled from 'styled-components';

import { Row } from '@simplywallst/ui-core';
import { media } from '@simplywallst/ui-core';

export const GalleryContainerRow = styled(Row)`
  width: 100%;
`;

export const Image = styled.img`
  height: 100%;
  width: 50%;
  ${media.lgUp`
    width: 100%;
    height: 100%;
  `}
`;
